export const endpoints = {
  userDrafts: 'case/draft/user/current',
  deleteCaseDraft: 'case/draft'
};
